export const validateEmail = (email: string) => {
    if (!email || email.trim() === "") return false
    return email
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
}

export const validateEmailsSeparatedByComma = (input: string) => {
    if (!input) return false
    const emails = input.split(',')
    let valid = true
    emails.forEach(email => {
        if (!validateEmail(email)) valid = false
    })
    return valid
}